import { NavLink, Link } from 'react-router-dom';

// ... inside the component return ...

{/* Navigation Menu */ }
<GlassCard className="p-2 space-y-1">
    <div className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wilder">
        My Career Hub
    </div>

    <NavLink
        to="/dashboard/profile"
        end
        className={({ isActive }) => `w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${isActive
            ? 'bg-blue-500/10 text-blue-400 border border-blue-500/20'
            : 'text-gray-400 hover:text-white hover:bg-white/5'
            }`}
    >
        <RiUser3Line className="text-lg" />
        <span className="font-medium">Profile</span>
        <span className="ml-auto opacity-0 group-hover:opacity-100">→</span>
    </NavLink>

    <NavLink
        to="/dashboard/profile/personal-info"
        className={({ isActive }) => `w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all ${isActive
            ? 'bg-blue-500/10 text-blue-400 border border-blue-500/20'
            : 'text-gray-400 hover:text-white hover:bg-white/5'
            }`}
    >
        <RiFileListLine className="text-lg" />
        <span className="font-medium">Personal Info</span>
        <span className="ml-auto opacity-0 group-hover:opacity-100">→</span>
    </NavLink>

    <button className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-gray-400 hover:text-white hover:bg-white/5 transition-all opacity-50 cursor-not-allowed">
        <RiBriefcaseLine className="text-lg" />
        <span className="font-medium">Job Preferences</span>
        <span className="ml-auto opacity-0 group-hover:opacity-100">→</span>
    </button>
</GlassCard>
import type { UserProfile } from '../../models/v2/profile';
import GlassCard from '../ui/v2/GlassCard';
import {
    RiUser3Line,
    RiFileListLine,
    RiPencilLine,
    RiBriefcaseLine
} from 'react-icons/ri';

interface Props {
    profile: UserProfile;
    email: string;
}

export default function ProfileSidebar({ profile }: Props) {
    const getInitials = (name: string) => {
        return name
            .split(' ')
            .map(n => n[0])
            .slice(0, 2)
            .join('')
            .toUpperCase();
    };

    const displayName = profile.preferred_name || 'Guest User';

    return (
        <div className="space-y-6">
            {/* Identity Card */}
            <GlassCard className="flex flex-col items-center text-center p-6 relative group">
                <Link
                    to="/dashboard/profile/personal-info"
                    className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
                >
                    <RiPencilLine />
                </Link>

                {/* Avatar */}
                <div className="mb-4 relative">
                    {profile.avatar_url ? (
                        <img
                            src={profile.avatar_url}
                            alt={displayName}
                            className="w-24 h-24 rounded-full object-cover border-4 border-white/5 shadow-xl"
                        />
                    ) : (
                        <div className="w-24 h-24 rounded-full bg-blue-500 flex items-center justify-center text-3xl font-bold text-white border-4 border-white/5 shadow-xl">
                            {getInitials(displayName)}
                        </div>
                    )}
                </div>

                {/* Name & Headline */}
                <h2 className="text-xl font-bold text-white mb-1">{displayName}</h2>
                <p className="text-sm text-gray-400 mb-4 px-2 leading-relaxed">
                    {profile.headline || 'No headline set'}
                </p>


            </GlassCard>

            {/* Navigation Menu */}
            <GlassCard className="p-2 space-y-1">
                <div className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase tracking-wilder">
                    My Career Hub
                </div>

                <NavLink
                    to="/dashboard/profile"
                    end
                    className={({ isActive }) => `w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all group ${isActive
                        ? 'bg-blue-500/10 text-blue-400 border border-blue-500/20'
                        : 'text-gray-400 hover:text-white hover:bg-white/5'
                        }`}
                >
                    <RiUser3Line className="text-lg" />
                    <span className="font-medium">Profile</span>
                    <span className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity">→</span>
                </NavLink>

                <NavLink
                    to="/dashboard/profile/personal-info"
                    className={({ isActive }) => `w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-all group ${isActive
                        ? 'bg-blue-500/10 text-blue-400 border border-blue-500/20'
                        : 'text-gray-400 hover:text-white hover:bg-white/5'
                        }`}
                >
                    <RiFileListLine className="text-lg" />
                    <span className="font-medium">Personal Info</span>
                    <span className="ml-auto opacity-0 group-hover:opacity-100 transition-opacity">→</span>
                </NavLink>
            </GlassCard>


        </div>
    );
}
